// Pages that keep unsaved edits in local state and seed it from their first
// query: refetching under them could reset what the user is editing, so the
// assistant offers a reload there instead of refreshing automatically.
const EDITING_SURFACES = [
  /^\/project\/[^/]+\/edit\/?$/,
  /^\/library\/[^/]+\/edit\/?$/,
  /^\/(project|library)\/[^/]+\/ai-studio\/?$/,
  /^\/clips\/[^/]+\/carousel\/?$/,
  /^\/clips\/[^/]+\/edit\/?$/,
];

export function isEditingSurface(pathname: string): boolean {
  return EDITING_SURFACES.some((pattern) => pattern.test(pathname));
}
